module.exports = __webpack_public_path__ + "img/scan (5).7ce460cc.jpg";